import LoginForm from "./LoginForm";
import { Link } from "react-router-dom";
import { FORGOT_PASSWORD } from "../../../shared/lib/routesResolver";

const LoginContainer = () => {
  return (
    <div className="mx-auto flex flex-col w-full justify-center space-y-6">
      <div className="flex flex-col space-y-2 text-center">
        <div className="flex justify-center">
          <img
            className="w-1/4"
            src="/login-form-logo.svg"
            alt="ADQUIVER MEDIA"
          />
        </div>
        <h1 className="text-2xl font-semibold tracking-tight">
          Control Centre
        </h1>
        <p className="text-sm text-muted-foreground">
          Por favor, introduzca sus credenciales
        </p>
      </div>
      <LoginForm />
      <div className="px-5 text-center text-sm underline text-adq-blue">
        <Link to={FORGOT_PASSWORD}>¿Has olvidado tu contraseña?</Link>
      </div>
    </div>
  );
};

export default LoginContainer;
